import { Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import MainContainer from "../../layout/MainContainer";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { isValidInput } from "../../utils/validations";
import { useLazyAllMembersByGroupQuery } from "../../service/user";
import { showError } from "../../constants/toasts";
import dayjs from "dayjs";

const ViewGroup = () => {
  const { id } = useParams();
  const location = useLocation();
  const title = location.state?.title;
  const [getMember] = useLazyAllMembersByGroupQuery();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [users, setUsers] = useState([]);

  const getUsersApi = async () => {
    setLoading(true);
    try {
      const response = await getMember({
        search: debouncedSearchTerm.trim(),
        id,
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setUsers(response?.data || []);
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getUsersApi();
  }, [debouncedSearchTerm]);

  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>{title || "View Group"}</h1>
          </div>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />

            <Button className="btn btn_primary">
              <img src="/static/images/export_icon.svg" alt="icon" /> Export
              Data
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() =>
                navigate(`/manage-cms/viewGroup/add-members/${id}`)
              }
            >
              {`${users?.length ? "Edit" : "Add"} Members`}
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/groups")}
            >
              Back
            </Button>
          </div>
        </div>
        <div className="cards table_cards">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Membership Type</th>
                  <th>Membership Status</th>
                  <th>Payment Status</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {users?.length ? (
                  users?.map((row: any, index) => (
                    <tr key={index} style={{ color: "#fff" }}>
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(`/manage-customers/detail/${row?.userId}`, {
                            state: {
                              status: "APPROVED",
                              memberType: row?.membershipType,
                            },
                          })
                        }
                      >
                        <img
                          src={"/static/images/user_placeholder.png"}
                          alt={row?.name || "-"}
                          style={{ width: 32, height: 32, borderRadius: "50%" }}
                        />
                        {row?.name || "-"}
                      </td>
                      <td>{row?.email || "-"}</td>
                      <td>{row?.membershipType || "-"}</td>
                      <td>{row?.membership || "-"}</td>
                      <td>{row.paymentStatus || "-"}</td>
                      <td>
                        {" "}
                        {dayjs(row?.createdAt).format(
                          "DD - MMMM - YYYY  |  hh:mm A"
                        )}
                      </td>
                    </tr>
                  ))
                ) : hasFetched ? (
                  <tr>
                    <td
                      colSpan={6}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </MainContainer>
    </>
  );
};
export default ViewGroup;
